// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__Gkex5","inner":"Form_inner__3AQUJ","range":"Form_range__2u0eo","name":"Form_name__2risC","actions":"Form_actions__1aK-e"};